import { lotusHealthSchemas } from '@lotushealth/lotushealth_js_sdk';

import type { CompoundRxDraft, CodedRxDraft, RxDraft, RxKind } from './types.js';

function todayIsoDate(): string {
  return new Date().toISOString().split('T')[0] ?? '';
}

export function createEmptyRxDraft(kind: RxKind): RxDraft {
  const common = {
    quantity: '',
    dispenseUnitId: '',
    directions: '',
    refills: '0',
    daysSupply: '',
    selectedPharmacy: null,
    pharmacyNotes: '',
    noSubstitutions: false,
    effectiveDate: todayIsoDate(),
    isUrgent: false,
    status: lotusHealthSchemas.MedicationStatusTInput.Active,
    comment: '',
    selectedDiagnosis: null,
  } as const;

  if (kind === 'coded') {
    const draft: CodedRxDraft = {
      kind: 'coded',
      selectedMedication: null,
      ...common,
    };
    return draft;
  }

  const draft: CompoundRxDraft = {
    kind: 'compound',
    compoundDescription: '',
    ingredients: [],
    ...common,
  };
  return draft;
}
